module.exports = __webpack_public_path__ + "static/media/home-marina-hovered.8533e57f.svg";